export function base64ToFile(dataURI: string, type: 'application/pdf' | 'image/jpeg' | 'image/png' | string) {
  const byteString = window.atob(dataURI.replace(/^data:.+;base64,/, ''))
  const arrayBuffer = new ArrayBuffer(byteString.length)
  const int8Array = new Uint8Array(arrayBuffer)
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i)
  }
  return new Blob([int8Array], { type: type })
}
